import {
  DEMO_FILL_JSON_FORM_MUTATION_KEY,
  type FillJsonFormDemoRequest,
  type FillJsonFormDemoResponse,
} from '@heidi/templates/contracts';
import { fillJsonFormDemo } from '@heidi/templates/data';
import { useMutation } from '@tanstack/react-query';

export function useMutateFillJsonFormDemo() {
  return useMutation<FillJsonFormDemoResponse, Error, FillJsonFormDemoRequest>({
    mutationKey: DEMO_FILL_JSON_FORM_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillJsonFormDemo(request);
      return data;
    },
  });
}
